// extracted by mini-css-extract-plugin
module.exports = {"globals":"\"../GlobalStyles.css\"","uiBlack":"#000000","boxAnimation":"1.68s ease"};